import { IPageInfoProps } from "./IPageInfoProps";
import { Button, Icon } from "@snpjs/core";
import styles from "./PageInfo.module.scss";

export const PageInfo: React.FC<IPageInfoProps & { isPageInfoOpen: boolean; onTogglePageInfo: () => void }> = (props) => {
  const collapsePageInfo = props.isPageInfoOpen; // Use prop instead of local state

  return (
    <div className={styles.pageInfo} onClick={props.onTogglePageInfo}>
      <div>
        {collapsePageInfo ? (
          <div className={styles.collapseIcon}>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onTogglePageInfo();
              }}
              icon="book-open-text"
              intent="primary"
            />
          </div>
        ) : (
          <Icon
            className={styles.collapseIcon}
            icon={"caret-right"}
            onClick={(e) => {
              e.stopPropagation();
              props.onTogglePageInfo();
            }}
          />
        )}
      </div>
      {!collapsePageInfo && (
        <div className={styles.infoArea}>
          <div className={styles.infoAreaDetails}>
            {props.infoArea && props.infoArea}
          </div>
        </div>
      )}
    </div>
  );
};
